import { render, staticRenderFns } from "./AngleControl.vue?vue&type=template&id=3bef2b96&scoped=true&"
import script from "./AngleControl.vue?vue&type=script&lang=js&"
export * from "./AngleControl.vue?vue&type=script&lang=js&"
import style0 from "./AngleControl.vue?vue&type=style&index=0&id=3bef2b96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bef2b96",
  null
  
)

export default component.exports